import React, { memo, useMemo, useCallback, Fragment } from 'react';
import { useTheme } from '@Sage/hoi-poi-ui';
import ContentLoader from 'react-content-loader';

import './styles.scss';

const ListLoader = memo(({ width, height }) => {
    const theme = useTheme();

    const getRow = useCallback(({ x, y, width }) => {
        return <rect x={x} y={y} rx="3" ry="3" width={width} height="20" />;
    }, []);

    const renderRows = useMemo(() => {
        let rows = [];
        let baseY = 20;
        let baseCircleY = 40;
        const rowHeight = 112;
        const numRows = Math.floor(height / rowHeight);
        const firstWidth = width * 0.3;
        const secondWidth = width * 0.18;
        const thirdWidth = width * 0.5;
        const fourthWidth = width * 0.13;
        const dateWidth = width * 0.2;

        const circleRadius = 20;
        const circlePosition = 44;
        const baseX = 80;
        const datePosition = width * 0.63;

        for (let i = 0; i < numRows; i++) {
            rows.push(
                <Fragment key={i}>
                    <circle cx={circlePosition} cy={baseCircleY} r={circleRadius} opacity="0.2" />
                    {getRow({ x: baseX, y: baseY, width: firstWidth })}
                    {getRow({ x: datePosition, y: baseY, width: dateWidth })}
                    {getRow({ x: baseX, y: baseY + 25, width: secondWidth })}
                    {getRow({ x: baseX, y: baseY + 25 * 2, width: thirdWidth })}
                    {getRow({ x: baseX, y: baseY + 25 * 3, width: fourthWidth })}
                </Fragment>,
            );
            baseCircleY = baseCircleY + rowHeight;
            baseY = baseY + rowHeight;
        }
        return rows;
    }, [width, height, getRow]);

    return (
        <div className="activities-list-placeholder">
            <ContentLoader
                height={height}
                width={width}
                speed={2}
                backgroundColor={theme.colors.grey[50]}
                foregroundColor={theme.colors.grey[100]}
            >
                {renderRows}
            </ContentLoader>
        </div>
    );
});

export default ListLoader;
